<template>
  <div class="rbu-item-module-data-points">
    <RbuItemModuleDataPoint
      v-for="(datapoint, idx) in datapoints"
      :key="idx"
      :datapoint="datapoint"
      :idx="idx"
      @input="onDataPointUpdate(idx, $event)"
      @delete="onDataPointDelete(idx)"
    ></RbuItemModuleDataPoint>
  </div>
</template>

<script>
import RbuDatapointInput from "@/components/rbu/RbuDatapointInput.vue";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import RbuItemModuleDataPoint from "@/components/rbu/RbuItemModuleDataPoint.vue";

export default {
  name: "RbuItemModuleDataPoints",
  components: { RbuItemModuleDataPoint, RbuPeriodInput, RbuDatapointInput },
  props: {
    item: Object,
    datapoints: Array,
  },
  setup(props, { root, emit }) {
    const onDataPointUpdate = function (idx, evt) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1, {
        ...props.datapoints[idx],
        ...evt,
      });
      emit("input", dataPoints);
    };

    const onDataPointDelete = function (idx) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1);
      emit("input", dataPoints);
    };

    return {
      onDataPointUpdate,
      onDataPointDelete,
    };
  },
};
</script>
